import { render } from "./CookiebarNotes.ce.vue?vue&type=template&id=b229071e"
import script from "./CookiebarNotes.ce.vue?vue&type=script&lang=js"
export * from "./CookiebarNotes.ce.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__